/**
 * Hook to load brand configuration from aws-exports.json.
 *
 * The brand section is injected by deploy-frontend.py at deploy time.
 */

import { useEffect, useState } from "react"

export interface BrandConfig {
  appTitle: string
  welcomeMessage: string
  favicon: string
  welcomeLogo?: string
}

const DEFAULT_BRAND: BrandConfig = {
  appTitle: "Polaris Agent",
  welcomeMessage: "ようこそ",
  favicon: "favicon.ico",
}

let cachedBrand: BrandConfig | null = null

async function fetchBrand(): Promise<BrandConfig> {
  if (cachedBrand) return cachedBrand
  try {
    const res = await fetch("/aws-exports.json")
    if (!res.ok) return DEFAULT_BRAND
    const config = await res.json()
    const brand = { ...DEFAULT_BRAND, ...(config.brand || {}) }
    cachedBrand = brand
    return brand
  } catch {
    return DEFAULT_BRAND
  }
}

export function useBrandConfig(): BrandConfig {
  const [brand, setBrand] = useState<BrandConfig>(cachedBrand || DEFAULT_BRAND)

  useEffect(() => {
    fetchBrand().then(setBrand)
  }, [])

  return brand
}
